export default function ({store}) {
  // close menu on new page
  store.commit('closeMenu')
}
